import React from "react";

interface InfoBoxProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ children, style, className }) => {
  return (
    <div
      className={className}
      style={{
        border: "2px solid #007bff",
        borderRadius: "8px",
        padding: "15px",
        backgroundColor: "#e9f5ff",
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default InfoBox;
